// TODO: should be renamed to FarmingLevel

export enum ReferralLevel {
  STARTER = 'STARTER',
  PARTNER = 'PARTNER',
  PRO = 'PRO',
  VIP = 'VIP',
  ELITE = 'ELITE',
  MAX = 'MAX',
}

export const REFERRER_QUERY_NAME = 'r'
export const REFERRER_LS_KEY = 'r'
